import { RouteTableColumn, RouteTableAction } from '../route-function-report/route-analysis-report/route-analysis-report.models';
import { VehicleFinanceRow } from './vehicle-finance-report.models';

export const FINANCE_REPAIR_COLUMNS: RouteTableColumn[] = [
  { field: 'strRepairman', title: 'نام تعمیرکار' },
  { field: 'strReason', title: 'موضوع' },
  { field: 'iTotalCost', title: 'هزینه (ریال)', numeric: true, totalField: 'iTotalCost', unit: 'ریال' },
  { field: 'iKM', title: 'مسافت طی‌شده (km)', numeric: true },
  { field: 'strDate', title: 'تاریخ' },
  { field: 'strUserSaved', title: 'کاربر ثبت‌کننده' },
];
export const FINANCE_INCOME_COLUMNS: RouteTableColumn[] = [
  { field: 'strComment', title: 'توضیحات' },
  { field: 'iAmount', title: 'مبلغ (تومان)', numeric: true, totalField: 'iAmount', unit: 'تومان' },
  { field: 'strDate', title: 'تاریخ' },
];
// Legacy summary adds the raw values; no currency conversion is introduced here.
export const FINANCE_SUMMARY_COLUMNS: RouteTableColumn[] = [
  { field: 'totalCost', title: 'جمع کل هزینه‌ها', numeric: true },
  { field: 'totalIncome', title: 'جمع کل درآمد', numeric: true },
  { field: 'balance', title: 'خالص درآمد/هزینه', numeric: true },
  { field: 'strComment', title: 'نتیجه' },
];
export const FINANCE_INVOICE_ACTIONS: RouteTableAction[] = [{ kind: 'invoice', title: 'نمایش فاکتور', icon: 'fa-file-image-o' }];
export const FINANCE_REPAIR_EXPORT_COLUMNS: RouteTableColumn[] = [
  { field: 'strComment', title: 'توضیحات' }, ...FINANCE_REPAIR_COLUMNS,
];
export const FINANCE_INCOME_EXPORT_COLUMNS: RouteTableColumn[] = [
  { field: 'strFullName', title: 'نام راننده' }, ...FINANCE_INCOME_COLUMNS,
];
export function financeSum(rows: VehicleFinanceRow[], field: 'iTotalCost' | 'iAmount'): number {
  return rows.reduce((sum, row) => sum + (Number(row[field]) || 0), 0);
}
export function financeSummary(repairs: VehicleFinanceRow[], income: VehicleFinanceRow[]): VehicleFinanceRow[] {
  if (!repairs.length && !income.length) return [];
  const totalCost = financeSum(repairs, 'iTotalCost');
  const totalIncome = financeSum(income, 'iAmount');
  const balance = totalIncome - totalCost;
  return [{ totalCost, totalIncome, balance, strComment: balance > 0 ? 'سود' : balance < 0 ? 'ضرر' : 'بدون سود و زیان' }];
}
export function invoiceImageMarkup(image: string): string | null {
  const base64 = image.replace(/\s/g, '');
  return base64 && /^[A-Za-z0-9+/]+={0,2}$/.test(base64)
    ? `<img src="data:image/jpeg;base64,${base64}" alt="فاکتور تعمیرات" class="img-fluid">`
    : null;
}
